import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { FaAngleLeft, FaPencil, FaPlus } from "react-icons/fa6";
import { MdClose, MdDelete } from "react-icons/md";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  useDeleteCoursesClass,
  useGetCourseClassById,
  useUpdateCourseClass,
} from "../../api/useProducts/useCourses";
import { useGetWorkOuts } from "../../api/useProducts/useWorkOut";
import {
  CustomButton,
  FileUploadIcon,
  FileUploadModal,
  InputField,
  Sidebar,
} from "../../components";
import Loader from "../../components/Loader";
import CustomPagination from "../../components/CustomPagination";
import useSingleFileUpload from "../../hook/useSingleFileUpload";
import Swal from "sweetalert2";
import VideoCard from "../../components/VideoCard";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
// Form data interface
interface WorkoutFormData {
  title?: string;
  description?: string;
  order?: number;
  file: UploadedData;
  id?: number;
}
interface UploadedData {
  url?: string;
  file?: File | null;
}
const UpdateCourseClass: React.FC = () => {
  const { id } = useParams();
  const [page, setPage] = useState(1);
  const { CourseClassData, CourseClassLoading, CourseClassRefetch } =
    useGetCourseClassById({
      page,
      limit: 5,
      courseId: Number(id),
    });

  const [classId, setClassId] = useState<Number>();
  const { mutate, isPending } = useUpdateCourseClass(Number(classId));
  const { mutate: mutateExercise } = useDeleteCoursesClass();
  const { uploadImage, isUploading } = useSingleFileUpload();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
    control,
  } = useForm<WorkoutFormData>();
  const [classList, setClassList] = useState<WorkoutFormData[]>([]);
  const [isClassList, setIsClassList] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [uploadedData, setUploadedData] = useState<UploadedData>({});
  const handleFileUpload = (data: UploadedData) => {
    setUploadedData(data);
  };
  const handleDelete = (id: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#24B1B3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        mutateExercise(
          { id },
          {
            onSuccess: (data) => {
              toast.success("successfully delete");
              CourseClassRefetch();
            },
            onError: (error: any) => {
              console.error("Error deleting item:", error);
              toast.error(error.response.data.message);
            },
          }
        );
      }
    });
  };

  const handleEdit = (value: any) => {
    setClassId(value?.id);
    setValue("description", value.description);
    setValue("order", value.order);
    setValue("title", value.title);
    setValue("title", value.title);
    setUploadedData({ url: value?.file?.url });
    setIsClassList(true);
  };
  const handleSave = async (data: any) => {
    let imageUrl;
    if (uploadedData.file) {
      imageUrl = await uploadImage(uploadedData.file);
    } else {
      imageUrl = uploadedData?.url;
    }
    mutate(
      {
        // @ts-ignore
        title: data?.title || "",
        description: data?.description || "",
        order: data?.order || "",
        courseId: id,
        ...(uploadedData && { media: imageUrl }),
      },
      {
        onSuccess: (data) => {
          toast.success("successfully update");
          // navigate(`/courses`);
          setUploadedData({});
          setIsClassList(false);
          reset();
          setClassId(undefined);
          CourseClassRefetch();
        },
        onError: (error: any) => {
          toast.error(error.response.data.message);
          setClassId(undefined);
        },
      }
    );
  };

  useEffect(() => {
    CourseClassRefetch();
  }, [id]);
  useEffect(() => {
    CourseClassRefetch();
  }, [page]);
  useEffect(() => {
    if (CourseClassData?.data) {
      const transformedExercises = CourseClassData?.data.map((value) => ({
        // file.url: value?.media,
        file: {
          url: value?.media,
          file: null,
        },
        order: value.order,
        title: value.title,
        description: value?.description,
        reps: value?.title,
        id: value?.id,
      }));

      // @ts-ignore
      setClassList(transformedExercises);
    }
  }, [id, CourseClassData]);
  const breadcrumbItems = [
    { title: "Courses", link: "courses" },
    { title: "Edit Class " },
  ];
  return (
    <Sidebar>
      {CourseClassLoading ? (
        <Loader />
      ) : (
        <>
          <div className="mt-3">
          <CustomBreadcrumb items={breadcrumbItems} />

          
            <div className="flex justify-between items-center my-2">
              <h1 className="text-2xl font-medium mb-4">
                Course Class{isClassList ? "" : "es"}
              </h1>
              {isClassList && (
                <CustomButton
                  handleClick={() => {
                    setIsClassList(false);
                    setClassId(undefined);
                  }}
                  icon={<MdClose size={22} />}
                  rounded="rounded-full"
                  padding="p-0"
                  addclass="mt-4 ms-auto w-8 h-8"
                />
              )}
            </div>
          </div>
          {!isClassList ? (
            <div>
              {classList?.length > 0 ? (
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 sm:grid-cols-3">
                  {" "}
                  {classList?.map((value, idx) => {
                    // @ts-ignore
                    return (
                      <div
                        key={idx}
                        className="border-2 border-darkCyan rounded-lg group mb-3 overflow-hidden relative"
                      >
                        <span
                          className="bg-darkCyan h-7 justify-center rounded-b-lg text-white w-7 absolute cursor-pointer end-8 group-hover:flex hidden items-center top-0 z-10"
                          onClick={() => handleEdit(value)}
                        >
                          <FaPencil size={16} />
                        </span>
                        <span
                          className="bg-darkCyan h-7 justify-center rounded-bl-lg text-white w-7 absolute cursor-pointer end-0 group-hover:flex hidden items-center top-0 z-10"
                          onClick={() => handleDelete(Number(value?.id))}
                        >
                          <MdDelete size={20} />
                        </span>
                        <VideoCard
                          media={value?.file?.url}
                          description={value?.description || ""}
                          title={value?.title || ""}
                        />
                        {/*   <p className="font-semibold">
                          title :
                          <span className="text-gray-500 font-normal ms-1.5">
                            {" "}
                            {value?.title}
                          </span>
                        </p>

                        <p className="flex font-semibold items-center">
                          Description :
                          <span className="text-gray-500 font-normal ms-1.5">
                            {sanitizedContent && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: sanitizedContent,
                                }}
                              />
                            )}
                          </span>
                        </p>
                        <div className="flex flex-wrap font-semibold items-center">
                          <p>Media :</p>
                          <p className="text-gray-500 break-all font-normal ms-1.5">
                            {value?.file?.url}
                          </p>
                        </div>
                        <p className="font-semibold">
                          Order :
                          <span className="text-gray-500 font-normal ms-1.5">
                            {value?.order}
                          </span>
                        </p> */}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex border-2 justify-center p-3 rounded-lg text-center items-center min-h-32 mt-4">
                  Data not found
                </div>
              )}
              <div>
                <div className="flex justify-end">
                  <CustomButton
                    handleClick={() => navigate(`/courses/class/add/${id}`)}
                    icon={<FaPlus size={25} />}
                    rounded="rounded-full"
                    padding="p-0"
                    addclass="mt-4  w-12 h-12"
                  />
                </div>
                <CustomPagination
                  page={page}
                  setPage={setPage}
                  totalPages={Number(CourseClassData?.meta?.lastPage)}
                />
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(handleSave)}>
              <div>
                <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
                  <InputField
                    label="Title"
                    placeholder="Enter title"
                    type="text"
                    register={register(`title`, {
                      required: "title are required",
                    })}
                    error={errors.title?.message}
                  />

                  <InputField
                    label="order"
                    placeholder="Enter order"
                    type="number"
                    register={register(`order`, {
                      required: "Order is required",
                      validate: (value) => {
                        // @ts-ignore
                        if (value <= 0) {
                          return "Order must be a positive number";
                        }
                        // @ts-ignore
                        if (!Number.isInteger(parseFloat(value))) {
                          return "Order must be a whole number";
                        }
                        return true;
                      },
                    })}
                    error={errors.order?.message}
                  />

                  <div className="mt-2">
                    <p className="text-gray-700 block mb-2">Description</p>
                    <Controller
                      name="description"
                      control={control}
                      rules={{ required: "description is required" }}
                      render={({ field }) => (
                        <ReactQuill
                          {...field}
                          // onChange={(value) => {
                          //   field.onChange(value);
                          // }}
                          className="quill-editor"
                          modules={{
                            toolbar: [
                              ["bold", "italic", "underline", "strike"],
                              ["blockquote", "code-block"],
                              [{ header: 1 }, { header: 2 }],
                              [{ list: "ordered" }, { list: "bullet" }],

                              [{ size: ["small", false, "large", "huge"] }],
                              [{ header: [1, 2, 3, 4, 5, 6, false] }],
                              [{ color: [] }, { background: [] }],

                              [{ align: [] }],
                              ["clean"],
                            ],
                          }}
                        />
                      )}
                    />
                    {errors.description && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.description.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <p className="text-gray-700 block mt-2">Upload video</p>

                    <div className="mt-3">
                      <div onClick={() => setModalOpen(true)}>
                        <div
                          role="button"
                          className="flex flex-col border-[1.5px] border-dashed border-gray-400 justify-center rounded-2xl items-center min-h-52"
                        >
                          {uploadedData.url ? (
                            <p className="text-center text-gray-600 text-sm">
                              Uploaded URL: {uploadedData.url}
                            </p>
                          ) : uploadedData.file ? (
                            <p className="text-center text-gray-600 text-sm">
                              Uploaded File: {uploadedData.file.name}
                            </p>
                          ) : (
                            <>
                              <FileUploadIcon />
                              <CustomButton btntext="Upload" addclass="mt-3" />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <CustomButton
                type="submit"
                isLoading={isPending}
                btntext="Save"
                addclass="mt-5 mx-auto w-1/2"
              />
            </form>
          )}
        </>
      )}
      <FileUploadModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        onFileUpload={handleFileUpload}
      />
    </Sidebar>
  );
};

export default UpdateCourseClass;
